import React, { useEffect, useState } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import moment from 'moment-timezone';
import { TableContainer } from '@mui/material';
import { Peginationcomponent } from '../../Component/Peginationcomponent';
import Loading from '../../Component/Loading';
import useTableSorting from '../../Hooks/useTableSorting';
import useReduxData from '../../Hooks/useReduxData';
import { NoRecordFound } from '../../Component/NoRecordFound';
import { RoleTitle } from '../../Context/constants';
import { LIST_BILLS, SHARE_PDF } from '../Repository/AppointmentsRepo';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Modal from 'react-bootstrap/Modal';
import useMuiCompontent from '../../Hooks/useMuiCompontent';
import html2pdf from 'html2pdf.js';

const AppointmentBills = ({ type }) => {
    const { CustomButton } = useMuiCompontent()
    const [billsData, setBillsData] = useState([])
    const [count, setCount] = useState(0)
    const [controller, setController] = useState({ page: 1, rowsPerPage: 10 });
    const { id, subpatientId } = useParams()
    const [loader, setloader] = useState(false)
    const { reduxData: userData } = useReduxData("userDataRDX")
    const { reduxData: MemberType, } = useReduxData("SubMemberTypeRDX")
    const [showModal, setShowModal] = useState(false);
    const [selectedBillId, setSelectedBillId] = useState(null);
    const [selectedRx, setSelectedRx] = useState(null);
    const [pdfUrl, setPdfUrl] = useState('');
    const [sending, setSending] = useState(false);


    const navigate = useNavigate()
    useEffect(() => {
        bills()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [controller])

    const bills = async () => {
        setloader(true)
        let payload = {
            providerId: (userData.roleTitle === RoleTitle.STAFF || userData.roleTitle === RoleTitle.FRONT_DESK) ? userData?.providerId : userData?.userId,
            patientId: type === "Patients" ? id : MemberType ? subpatientId : subpatientId,
            staffId: userData.roleTitle === RoleTitle.STAFF ? userData?.userId : undefined,
            frontdeskId: userData.roleTitle === RoleTitle.FRONT_DESK ? userData?.userId : undefined,
            roleTitle: userData.roleTitle,
            page: controller.page,
            count: controller.rowsPerPage,
        }
        try {
            let response = await LIST_BILLS(payload)
            const billsDataWithPatient = response?.data.map(bill => ({
                ...bill,
                patientName: `${bill.patientFirstName || ''} ${bill.patientLastName || ''}`.trim(),
                mobile: bill.patientMobile || '',
                appointmentId: bill.appointmentId || '',
                patientNumber: bill.patientNumber || '',
            }));
            setBillsData(billsDataWithPatient)
            setloader(false)
            setCount(response.totalCount)
        } catch (error) {
            setBillsData([])
            setCount(0)
            setloader(false)
        }

    }

    const headCells = [
        { id: "appointmentNumber", numeric: false, disablePadding: true, label: "Appointment Number", showIcon: true },
        { id: "serviceName", numeric: false, disablePadding: true, label: "Service Name", showIcon: true },
        { id: "date", numeric: false, disablePadding: true, label: "Date", showIcon: true },
        { id: "time", numeric: true, disablePadding: false, label: "Time" },
        { id: "doctor", numeric: true, disablePadding: false, label: "Doctor", showIcon: true },
        { id: "visitType", numeric: true, disablePadding: false, label: "Visit Type", showIcon: true },
        { id: "action", numeric: false, disablePadding: false, label: "Action", showLeft: true }
    ];
    const { EnhancedTableHead, order, orderBy, stableSort, getComparator, handleRequestSort } = useTableSorting(headCells)

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedBillId(null);
        setPdfUrl('');
    };

    const handleShareBill = (billId) => {
        setSelectedBillId(billId);
        setShowModal(true);
    };

    const handleShareRx = (appointmentId) => {
        setSelectedRx(appointmentId);
        setShowModal(true);
    };

    // const generateBillPDFBlob = async (billId) => {
    //     const url = (type === "Patients")
    //         ? `/patients/${id}/view-patient-bill/${billId}`
    //         : `/patients/${id}/sub-members/${subpatientId}/view-patient-bill/${billId}`;

    //     return new Promise((resolve, reject) => {
    //         const iframe = document.createElement('iframe');
    //         iframe.style.display = 'none';
    //         iframe.src = window.location.origin + url;

    //         const maxRetries = 20;
    //         let retryCount = 0;

    //         const checkIfContentLoaded = () => {
    //             const doc = iframe.contentWindow.document;
    //             const billContent = doc.querySelector('.patient_bill');
    //             if (billContent && billContent.innerText.trim() !== "" && doc.querySelector('.footer-row')) {
    //                 html2pdf()
    //                     .set({
    //                         margin: 3,
    //                         image: { type: 'jpeg', quality: 1 },
    //                         html2canvas: { scale: 2, useCORS: true, logging: true, windowWidth: 794, windowHeight: 1123 },
    //                         jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    //                         pagebreak: { mode: [], avoid: ['table', '.note', '.footer-row'] }
    //                     })
    //                     .from(billContent)
    //                     .outputPdf('blob')
    //                     .then(blob => {
    //                         document.body.removeChild(iframe);
    //                         resolve(blob);
    //                     })
    //                     .catch(err => {
    //                         document.body.removeChild(iframe);
    //                         reject(err);
    //                     });
    //             }
    //             else if (retryCount >= maxRetries) {
    //                 document.body.removeChild(iframe);
    //                 reject(new Error('Timeout: Bill content failed to load'));
    //             }
    //             else {
    //                 retryCount++;
    //                 setTimeout(checkIfContentLoaded, 300);
    //             }
    //         };
    //         const handleLoad = () => {
    //             checkIfContentLoaded();
    //         };

    //         iframe.onload = handleLoad;
    //         document.body.appendChild(iframe);

    //         iframe.onerror = () => {
    //             document.body.removeChild(iframe);
    //             reject(new Error('Failed to load the bill page'));
    //         }
    //     });
    // };

    const sendBillPDFToWhatsApp = async (billId) => {
        if (sending) return;
        setloader(true);

        try {
            // const blob = await generateBillPDFBlob(billId);
            const billData = billsData.find(bill => bill.billId === billId);

            const payload = {
                mobile: billData?.mobile,
                name: billData?.patientName,
                billId: billData?.billId,
                patientId: type === "Patients" ? id : MemberType ? subpatientId : subpatientId,
                providerId: (userData.roleTitle === RoleTitle.STAFF || userData.roleTitle === RoleTitle.FRONT_DESK) ? userData?.providerId : userData?.userId,
                // file: blob  <-- only include if backend expects base64/pdf string
            };

            // const formData = new FormData();
            // // formData.append('file', blob, 'patientBill.pdf');
            // formData.append('mobile', billData?.mobile);
            // formData.append('name', billData?.patientName);
            // formData.append('billId', billData?.billId);

            // formData.append(
            //     'providerId',
            //     (userData.roleTitle === RoleTitle.STAFF || userData.roleTitle === RoleTitle.FRONT_DESK)
            //         ? userData?.providerId
            //         : userData?.userId
            // );

            // if (userData.roleTitle === RoleTitle.STAFF) {
            //     formData.append('staffId', userData.userId);
            // }

            // if (userData.roleTitle === RoleTitle.FRONT_DESK) {
            //     formData.append('frontdeskId', userData.userId);
            // }

            // formData.append('roleTitle', userData.roleTitle);

            const response = await SHARE_PDF(payload);

            toast.success(response.message)
            setShowModal(false);
        } catch (error) {
            console.error(error);
            toast.error(error?.message);
        } finally {
            setloader(false);
        }
    };

    // const generateRxPDFBlob = async () => {
    //     return new Promise((resolve, reject) => {
    //         const iframe = document.createElement('iframe');
    //         iframe.style.display = 'none';
    //         document.body.appendChild(iframe);

    //         const doc = iframe.contentDocument || iframe.contentWindow.document;
    //         doc.open();
    //         doc.write('<!DOCTYPE html><html><head></head><body></body></html>');
    //         doc.close();

    //         // Clone already rendered checkout content
    //         const sourceContent = document.querySelector('.checkout_clip_container');
    //         if (!sourceContent) {
    //             document.body.removeChild(iframe);
    //             return reject(new Error("Source content not found"));
    //         }

    //         const clone = sourceContent.cloneNode(true);
    //         doc.body.appendChild(clone);

    //         // Wait for images (if any)
    //         waitForImagesToLoad(doc).then(() => {
    //             html2pdf()
    //                 .set({
    //                     margin: 8,
    //                     image: { type: 'jpeg', quality: 1 },
    //                     html2canvas: { scale: 2, useCORS: true },
    //                     jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
    //                 })
    //                 .from(clone)
    //                 .outputPdf('blob')
    //                 .then(blob => {
    //                     document.body.removeChild(iframe);
    //                     resolve(blob);
    //                 })
    //                 .catch(err => {
    //                     document.body.removeChild(iframe);
    //                     reject(err);
    //                 });
    //         }).catch(err => {
    //             document.body.removeChild(iframe);
    //             reject(err);
    //         });
    //     });
    // };

    // const waitForImagesToLoad = (doc) => {
    //     const allImgs = Array.from(doc.images);
    //     return Promise.all(
    //         allImgs.map((img) => {
    //             if (img.complete) return Promise.resolve();
    //             return new Promise((res) => {
    //                 img.onload = img.onerror = res;
    //             });
    //         })
    //     );
    // };



    const sendPrescriptionPDF = async (appointmentId) => {
        if (sending) return;
        setloader(true);

        try {
            // const blob = await generateRxPDFBlob(appointmentId);
            const billData = billsData.find(bill => bill.appointmentId === appointmentId);

            const payload = {
                mobile: billData?.mobile,
                name: billData?.patientName,
                appointmentId: billData?.appointmentId,
                patientId: type === "Patients" ? id : MemberType ? subpatientId : subpatientId,
                providerId: (userData.roleTitle === RoleTitle.STAFF || userData.roleTitle === RoleTitle.FRONT_DESK) ? userData?.providerId : userData?.userId,
                // file: blob  <-- only include if backend expects base64/pdf string
            };

            // const formData = new FormData();
            // formData.append('file', blob, `${billData?.patientNumber}_checkout_slip.pdf`);
            // formData.append('mobile', billData?.mobile);
            // formData.append('name', billData?.patientName);
            // formData.append(
            //     'providerId',
            //     (userData.roleTitle === RoleTitle.STAFF || userData.roleTitle === RoleTitle.FRONT_DESK)
            //         ? userData?.providerId
            //         : userData?.userId
            // );

            // if (userData.roleTitle === RoleTitle.STAFF) {
            //     formData.append('staffId', userData.userId);
            // }

            // if (userData.roleTitle === RoleTitle.FRONT_DESK) {
            //     formData.append('frontdeskId', userData.userId);
            // }

            // formData.append('roleTitle', userData.roleTitle);

            const response = await SHARE_PDF(payload);

            toast.success(response.message)
            setShowModal(false);
        } catch (error) {
            console.error(error);
            toast.error(error?.message);
        } finally {
            setloader(false);
        }
    };



    return (
        <>
            {loader && <Loading />}
            <div className=" d-flex flex-column justify-content-between " style={{ height: "100%" }}>
                <div>
                    <TableContainer >
                        {billsData?.length === 0 &&
                            <div className="col-sm-12 mt-3 text-center " >  <NoRecordFound />  </div>
                        }
                        <Table
                            id="table_mui"
                            aria-labelledby="tableTitle"
                            size={"medium"}
                            aria-label="enhanced table"
                        >
                            {
                                billsData.length !== 0 && <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} rowCount={billsData.length} />
                            }
                            <TableBody>

                                {
                                    stableSort(billsData, getComparator(order, orderBy)).map(
                                        (row, index) => {
                                            const labelId = `enhanced-table-checkbox-${index}`;
                                            return <React.Fragment key={index}><TableRow hover id="hover_tr" >
                                                <TableCell className="ps-3" id={labelId} scope="row" padding="none" >
                                                    {row?.appointmentNumber}
                                                </TableCell>
                                                <TableCell id={labelId} align="left">{row.serviceName}</TableCell>
                                                <TableCell id={labelId}>
                                                    {row?.startDate
                                                        ? moment(row.startDate).tz(userData?.timezoneName || moment.tz.guess()).format('ll')
                                                        : 'N/A'}
                                                </TableCell>

                                                <TableCell id={labelId} align="left">
                                                    {(row?.startDate && row?.endDate)
                                                        ? `${moment(row.startDate).tz(userData?.timezoneName || moment.tz.guess()).format('LT')} - ${moment(row.endDate).tz(userData?.timezoneName || moment.tz.guess()).format('LT')}`
                                                        : 'N/A'}
                                                </TableCell>

                                                <TableCell id={labelId} align="left">{row.doctorFirstName + " " + row.doctorLastName}</TableCell>
                                                <TableCell id={labelId} align="left">{row.visitType}</TableCell>
                                                <TableCell id={labelId} align="right">
                                                    <MoreVertIcon
                                                        type="button"
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded="false"
                                                    />
                                                    <ul className="dropdown-menu dropdown-menu-end me-3" >
                                                        <li><button className="dropdown-item" href="#" onClick={() => { const url = (type === "Patients") ? `/patients/${id}/view-patient-bill/${row.billId}` : `/patients/${id}/sub-members/${subpatientId}/view-patient-bill/${row.billId}`; navigate(url); }}><i style={{ fontSize: "12px", color: "#888686 ", width: "20px", }} className="fa-solid fa-eye  all_icons_color "></i>View Details</button></li>
                                                        {/* <li><button className="dropdown-item" href="#"
                                                            // disabled
                                                            // style={{ opacity: 0.5, cursor: "not-allowed" }}
                                                            onClick={() => handleShareBill(row?.billId)}
                                                        ><i style={{ fontSize: "12px", color: "#888686 ", width: "20px", }} className="fa-solid fa-share-from-square " ></i>Share Bill</button></li> */}
                                                        <li><button className="dropdown-item" href="#" onClick={() => {
                                                            const url = (type === "Patients")
                                                                ? `/patients/${id}/checkout-slip/${row?.appointmentId}`
                                                                : `/patients/${id}/sub-members/${subpatientId}/checkout-slip/${row?.appointmentId}`;
                                                            navigate(url);
                                                        }}
                                                            disabled={!row?.prescriptionNumber}
                                                            style={!row?.prescriptionNumber ? { opacity: 0.5, cursor: "not-allowed" } : {}}
                                                        ><i style={{ fontSize: "12px", color: "#888686 ", width: "20px", }} className="fa-solid fa-eye  all_icons_color"></i>view Prescription</button></li>
                                                        {/* <li><button className="dropdown-item pt-0" href="#"
                                                            disabled={!row?.prescriptionNumber}
                                                            style={!row?.prescriptionNumber ? { opacity: 0.5, cursor: "not-allowed" } : {}}
                                                            // disabled
                                                            // style={{ opacity: 0.5, cursor: "not-allowed" }}
                                                            onClick={() => handleShareRx(row?.appointmentId)}
                                                        ><i style={{ fontSize: "12px", color: "#888686 ", width: "20px", }} class="fa-solid fa-share-from-square"></i>Share Prescription</button></li> */}
                                                    </ul>
                                                </TableCell>
                                            </TableRow>
                                            </React.Fragment>
                                        }
                                    )
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                <div className='w-100 3'>
                    {count > 10 && <Peginationcomponent count={count} controller={controller} setController={setController} />}
                </div>
            </div>

            <Modal show={showModal} onHide={handleCloseModal} centered>
                <Modal.Body>
                    <div className="text-center">
                        <p className="modal-title mb-0">{selectedBillId ? "Bill PDF" : "E-prescription"}</p>
                    </div>
                    <hr />
                    <div className="text-center" style={{ padding: '10px' }}>
                        <i className="fa-solid fa-file-pdf" style={{ fontSize: '60px', color: '#d32f2f' }}></i>
                    </div>
                    <div className="text-center mt-3">
                        <CustomButton style={{ backgroundColor: '#38C4B9' }} variant="primary" disabled={sending} onClick={() => selectedBillId ? sendBillPDFToWhatsApp(selectedBillId) : sendPrescriptionPDF(selectedRx)}>
                            Send
                        </CustomButton>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AppointmentBills
